import { useTranslation } from "react-i18next"
import { ProductEntity } from "../../Objects/ProductsAndCatalogItems/ProductEntity"
import { productsMemory } from "../../Objects/Memory/Memory"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { GetRequest } from "../../services/ApiClientService"

export const useGetProducts = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleGetProducts = async (
    onSuccess: () => void,
    rote: string = API_ROUTES.PRODUCT.GET_ALL,
    showGlobalLoading = true,
  ) => {
    if (showGlobalLoading) {
      enableLoad()
    }

    try {
      const response = await GetRequest<ProductEntity[]>(rote)

      if (response.success) {
        const temp = response.data?.map((ss) => new ProductEntity(ss)) ?? []

        productsMemory.setList(temp)

        onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      if (showGlobalLoading) {
        disableLoad()
      }
    }
  }

  return {
    handleGetProducts,
  }
}
